import { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import "./SiSu.css";
import { actionCreators } from '../../store/AccountStore';
import "react-toastify/dist/ReactToastify.css";

class ExternalOperation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            repassword: '',
            submitted: false,
            loading: false,
            error: '',
            code: null
        };
    }

    componentDidMount() {
        if (this.props.location.search !== "") {
            const search = this.props.location.search;
            const params = new URLSearchParams(search);
            const ref = params.get('ref');
            this.setState({ code: ref });
            this.props.getExtOpDetails(ref);
        }
    }

    render() {
        return null;
    }
}

export default connect(
    state => state.account,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ExternalOperation);


// WEBPACK FOOTER //
// ./src/view/Account/ExternalOperation.js